<template>
  <div class="content list-list list">
    <div class="row">
      <div class="col-sm-12">
        <el-card>
          <h4 style="color: #3b291d">Operation View</h4>
          <!-- Start search part -->
          <div class="row">
            <div class="col-sm-4">
              <base-input label="Campaign Date Range" class="range-picker">
                <el-date-picker
                  type="daterange"
                  placeholder="Campaign Date Range"
                  v-model="searchKey.campaignDate2"
                  class="form-control"
                  value-format="YYYY-MM-DD"
                  format="DD/MM/YYYY"
                >
                </el-date-picker>
              </base-input>
            </div>

            <div class="col-sm-2">
              <base-input
                placeholder=""
                label="Salesman"
                v-model="searchKey.salesName"
              >
                <el-select
                  clearable
                  @blur="selectBlur"
                  v-model="searchKey.searchData.salesName"
                  class="select-primary"
                  size="large"
                  filterable
                  style="width: 100%"
                  placeholder="Salesman"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in SalesList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>
            <div class="col-sm-2">
              <base-input label="Platform" v-model="searchKey.platform">
                <el-select
                  v-model="searchKey.searchData.platform"
                  class="select-primary"
                  filterable
                  size="large"
                  placeholder=""
                >
                  <el-option label="Bus Interior" value="Bus Interior">
                  </el-option>
                  <el-option label="Bus Shelter" value="Bus Shelter">
                  </el-option>
                  <el-option label="Bus Exterior" value="Bus Exterior">
                  </el-option>
                  <el-option label="Bus Domination" value="Bus Domination">
                  </el-option>
                  <el-option label="Whole Bus" value="Whole Bus"> </el-option>
                  <el-option label="Apps" value="Apps"> </el-option>
                </el-select>
              </base-input>
            </div>
          </div>
          <div class="row">
            <!-- <div class="col-sm-4">
              <base-input label="Submission Date" class="range-picker">
                <el-date-picker
                  type="daterange"
                  placeholder=""
                  v-model="searchKey.submissionDate2"
                  class="form-control"
                  value-format="YYYY-MM-DD"
                  format="DD/MM/YYYY"
                >
                </el-date-picker>
              </base-input>
            </div> -->
            <div class="col-sm-4">
              <base-input label="Signed Date" class="range-picker">
                <el-date-picker
                  type="daterange"
                  v-model="searchKey.signedDate2"
                  class="form-control"
                  value-format="YYYY-MM-DD"
                  format="DD/MM/YYYY"
                >
                </el-date-picker>
              </base-input>
            </div>
            <div class="col-sm-4">
              <base-input placeholder="" label="Campaign Name">
                <el-input
                  clearable
                  style="
                    border: 1px solid hsl(0, 0%, 5%);
                    border-radius: 5px;
                    --el-input-focus-border-color: #f0f3f7;
                    margin-top: 4px;
                  "
                  v-model="searchKey.searchData.campaignName"
                >
                </el-input>
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <base-input placeholder="" label="Contracting Party / Advertiser">
                <el-input
                  clearable
                  style="
                    border: 1px solid hsl(0, 0%, 5%);
                    border-radius: 5px;
                    --el-input-focus-border-color: #f0f3f7;
                    margin-top: 4px;
                  "
                  v-model="searchKey.advertiserName"
                >
                </el-input>
              </base-input>
            </div>
            <div class="col-sm-4">
              <base-input placeholder="" label="Order No. / Contract No.">
                <el-input
                  clearable
                  style="
                    border: 1px solid hsl(0, 0%, 5%);
                    border-radius: 5px;
                    --el-input-focus-border-color: #f0f3f7;
                    margin-top: 4px;
                  "
                  v-model="searchKey.orderOrContractNo"
                >
                </el-input>
              </base-input>
            </div>
          </div>
          <div class="row">
            <div style="width: 100%">
              <div style="column-gap: 5px; text-align: right">
                <base-button type="primary" @click="search">Search</base-button>
                <base-button type="primary" @click="reset">Reset</base-button>
                <base-button type="primary" @click="exportExcel"
                  >Export Excel</base-button
                >
              </div>
            </div>
          </div>
          <!-- end Search part-->
          <div class="row" style="margin-top: 20px">
            <div class="col-sm-12" style="display: flex">
              <span
                style="
                  margin-left: auto;
                  line-height: 32px;
                  padding-right: 20px;
                "
              >
                Total No. of Record: {{ searchKey.total }}
                <base-pagination
                  class="pagination-no-border"
                  v-model="searchKey.pageIndex"
                  :total="searchKey.total"
                  :pagesToDisplay="10"
                  style="float: right"
                  :value="searchKey.pageIndex"
                  @changePage="ChangePageSearch"
                  @nextPage="ChangePageSearch"
                >
                </base-pagination>
              </span>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12">
              <el-table
                :data="list"
                style="width: 100%"
                border
                header-row-class-name="header-row"
                @filter-change="filterChange"
                class="report"
                table-layout="auto"
              >
                <tablecolumnClick
                  prop="orderNumber"
                  label="Order No."
                  :width="100"
                />
                <!-- <el-table-column
                  prop="contractStatus"
                  label="Contract Status"
                  :filters="typeList.ContractStatusTypeList"
                  filter-placement="bottom-end"
                  :width="140"
                  column-key="contractStatusTypes"
                />
                <el-table-column
                  prop="submissionDate"
                  label="Submission Date"
                  :formatter="formatterCellDate"
                  width="160"
                /> -->
                <el-table-column
                  prop="submissionDate"
                  label="Issue Date"
                  :formatter="formatterCellDateTime"
                  width="140"
                />
                <el-table-column
                  prop="signed"
                  label="Signed"
                  :filters="typeList.SignedTypeList"
                  filter-placement="bottom-end"
                  :width="100"
                  column-key="signedTypes"
                />
                <el-table-column
                  prop="signedDate"
                  label="Signed Date"
                  :formatter="formatterCellDateTime"
                  width="140"
                />
                <el-table-column prop="ref" label="Ref" width="100" />

                <tablecolumn prop="salesName" label="SalesName" :width="130" />

                <el-table-column
                  prop="contractNumberProduction"
                  label="Contract No.(Production)"
                  :width="200"
                />
                <el-table-column
                  prop="contractNumberMedia"
                  label="Contract No.(Media/Main)"
                  :width="200"
                />
                <el-table-column
                  prop="opsContractNo"
                  label="Ops Contract No."
                  :width="180"
                />
                <el-table-column prop="logRef" label="Log.Ref." width="350" />
                <tablecolumn
                  prop="advertiserName"
                  label="Advertiser Name"
                  :width="250"
                />
                <tablecolumn
                  prop="campaignName"
                  label="Campaign Name"
                  :width="140"
                />
                <tablecolumn prop="format" label="Ad formats" :width="140" />
                <tablecolumn prop="platform" label="Platform" :width="110" />
                <tablecolumn
                  prop="busOperator"
                  label="Bus Operator"
                  :width="120"
                />
                <el-table-column prop="traceNo" label="Trace No." width="80" />
                <tablecolumn
                  prop="shortName"
                  label="Format/Short Name"
                  :width="150"
                />
                <tablecolumn prop="noofbus" label="No. of bus" :width="120" />
                <el-table-column
                  prop="logStartDate"
                  label="Log Start Date"
                  width="150"
                  :formatter="formatterCellDate"
                />
                <el-table-column
                  prop="logEndDate"
                  label="Log End Date"
                  width="150"
                  :formatter="formatterCellDate"
                />
                <tablecolumn
                  prop="committedBonus"
                  label="Committed Bonus"
                  :width="140"
                />
                <tablecolumn prop="period" label="Period" :width="120" />
                <tablecolumn prop="remark" label="Remark" :width="320" />
                <el-table-column
                  prop="postTimeType"
                  label="Post Time Type"
                  :filters="typeList.PostDateTypeList"
                  filter-placement="bottom-end"
                  :width="150"
                  column-key="postTimeTypes"
                />

                <el-table-column
                  prop="postTime"
                  label="Post Time"
                  :formatter="formatterCellDate"
                  width="150"
                />
                <el-table-column
                  prop="depostTimeType"
                  label="Depost Time Type"
                  :filters="typeList.DepostDateTypeList"
                  filter-placement="bottom-end"
                  :width="150"
                  column-key="depostTimeTypes"
                />
                <el-table-column
                  prop="depostTime"
                  label="Depost Time"
                  :formatter="formatterCellDate"
                  width="150"
                />
                <el-table-column
                  prop="sinFungJobNo"
                  label="Sin Fung Job No."
                  width="120"
                />
                <tablecolumn prop="category" label="Category" :width="120" />
              </el-table>
              <div></div>
            </div>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script setup>
import './css/index.css';
import { ref, reactive, onBeforeMount, onMounted } from 'vue';
import baseInput from '@/components/newUI/Inputs/BaseInput';
import baseButton from '@/components/newUI/BaseButton';
import basePagination from '@/components/newUI/BasePagination';
import PubSub from 'pubsub-js';
import router from '@/router';
import { ElMessageBox } from 'element-plus';
import { useAuthorityStore } from '@/store/authority';
// router
// import router from "@/router";
// api
import reportapi from '@/network/report';
// components
import tablecolumn from '@/components/tablecolumn';
import tablecolumnClick from '@/components/tablecolumnClick';
import booknet from '@/network/booknet';
// icon
// import { Edit, Search } from "@element-plus/icons-vue";

// tool
import {
  formatterCellDate,
  formatterCellDateTime,
} from '@/assets/js/formatter';

const SalesList = ref([]);
//const result = ref("");
//变更分页
const ChangePageSearch = async (data) => {
  searchKey.pageIndex = data;
  search();
};
//搜索条件实体
const searchKey = reactive({
  pageIndex: 1,
  pageSize: 10,
  searchData: {},
});
const typeList = reactive({
  PostDateTypeList: [],
  DepostDateTypeList: [],
  SignedTypeList: [
    { text: 'Open', value: 'Open' },
    { text: 'Approving', value: 'Approving' },
    { text: 'Signed', value: 'Signed' },
  ],
  ContractStatusTypeList: [
    { text: 'Open', value: 'Open' },
    { text: 'Approving', value: 'Approving' },
    { text: 'Signed', value: 'Signed' },
    { text: 'Revised', value: 'Revised' },
  ],
});

// #region datas
const list = ref([]);
// #endregion

onBeforeMount(async () => {
  //判断是否有权限查看,没有权限跳转主页
  await IsAuthority();
  await search();
  // 读取基本的Option
  const optionals1 = await booknet.GetOrderSalesmanList().then((res) => res);
  // 销售员选项
  SalesList.value = optionals1.data;
});
//判断是否有权限查看,没有权限跳转主页
const IsAuthority = async () => {
  if (!useAuthorityStore().GetAuthority('Menu_Operation_read')) {
    await ElMessageBox.alert('No permission.', 'Message', {
      confirmButtonText: 'OK',
    })
      .then(() => {
        //跳转主页
        router.push({
          name: 'report',
        });
      })
      .catch(() => {
        //跳转主页
        router.push({
          name: 'report',
        });
      });
  }
};

// event: 搜索
const search = async (data) => {
  console.log('search', data);
  searchKey.isToExcel = false;
  const search_res = await reportapi
    .getOperationView(searchKey)
    .then((res) => res);
  //总数
  searchKey.total = search_res.data.total;
  //数据列表
  list.value = search_res.data.list;
  typeList.PostDateTypeList = search_res.data.postDateTypeList;
  typeList.DepostDateTypeList = search_res.data.depostDateTypeList;
};
//导出数据到excel
const exportExcel = async () => {
  searchKey.isToExcel = true;
  const result = await reportapi.getOperationView(searchKey).then((res) => res);
  //if (result.statusText === 'OK') {
  if (result.status === 200) {
    const link = document.createElement('a');
    link.href = result.data;
    link.click();
  }
  searchKey.isToExcel = false;
};
//重置筛选条件
const reset = async () => {
  //清空对象
  Object.keys(searchKey).map((key) => {
    delete searchKey[key];
  });
  searchKey.pageIndex = 1;
  searchKey.pageSize = 10;
  searchKey.searchData = {};
  search();
};
const filterChange = async (filters) => {
  console.log('filtersfilters', filters);
  if (filters.postTimeTypes) {
    searchKey.postTimeTypes = filters.postTimeTypes;
  }
  if (filters.depostTimeTypes) {
    searchKey.depostTimeTypes = filters.depostTimeTypes;
  }
  if (filters.signedTypes) {
    searchKey.signedTypes = filters.signedTypes;
  }
  if (filters.contractStatusTypes) {
    searchKey.contractStatusTypes = filters.contractStatusTypes;
  }

  await search();
};
//组件传值
onMounted(async () => {
  PubSub.subscribe('mode', (name, data) => {
    // 动态赋值
    searchKey[`${data.key}`] = data.value;
    search();
  });

  PubSub.subscribe('modeclick', (name, data) => {
    router.push({
      name: 'order',
      query: {
        OrderNo: data.orderNumber,
      },
      params: {
        mode: 'view',
        id: data.orderId,
      },
    });
  });
});
</script>

<style scoped>
.list {
  font-size: 13px;
}
.searchs {
  width: 1213px;
  display: flex;
  flex-wrap: wrap;
  padding: 5px 0;
}
.searchs-item {
  line-height: 2.1rem;
  display: flex;
}

.searchs-item .searchs-item-control {
  padding: 0 50px 0 10px;
}

.filter-cell {
  height: 32px;
}

.filter-cell-title {
  padding: 5px 0;
}

.filter-cell-icon {
  position: absolute;
  top: 0;
  right: 12px;
}
.filter-cell-control {
  min-width: 230px;
}
.el-pagination {
  float: right;
}
</style>
<style>
.content.list-list .form-group.has-label .el-input__inner {
  position: relative;
  top: 5px;
}
</style>
